import React from 'react';
import css from './Instruction.module.css';
import {
  Paragraph,
  StackedColumn,
  StackedColumnSpacing,
} from '../../../../core';
import { ReminderInstruction } from '../../../../api/models';

interface InstructionProps {
  reminderInstruction: ReminderInstruction;
}

const Instruction: React.FC<InstructionProps> = (props: InstructionProps) => {
  return (
    <StackedColumn spacing={StackedColumnSpacing.NoGap}>
      <Paragraph text={props.reminderInstruction.title ?? ''} bold={true} />
      <Paragraph
        className={css.instructionText}
        text={props.reminderInstruction.text ?? ''}
      />
    </StackedColumn>
  );
};

export default Instruction;
